import Hero from "./Hero";
import ExperienceRow from "./ExperienceRow";
import SoftwareRow from "./SoftwareRow";
import PapersRow from "./PapersRow";
import SkillsSection from "./SkillsSection";
import AboutSection from "./AboutSection";
import ContactSection from "./ContactSection";

const Home = () => {
    return (
        <div className="min-h-screen bg-black">
            <Hero />
            <ExperienceRow />
            <SoftwareRow />
            <PapersRow />
            <SkillsSection />
            <AboutSection />
            <ContactSection />
        </div>
    );
};

export default Home;
